import React, { Component } from "react";

class DefaultFooter extends Component {
  render() {
    return (
      <React.Fragment>
        <span>
          &copy; {new Date().getFullYear()}{" "}
          <a href="https://www.nbc.org.kh"> National Bank of Cambodia</a>, All
          Rights Reserved. Email:{" "}
          <a target="_top" href="mailto:bakong@nbc.org.kh">
            bakong@nbc.org.kh
          </a>
        </span>
      </React.Fragment>
    );
  }
}

export default DefaultFooter;
